var _g, _g2, _g3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ekOh59TsmJq1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 702 502",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 32,
    transform: "translate(364 32)",
    fill: "#062"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 32,
    transform: "translate(364 191)",
    fill: "#062"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 155,
    rx: 0,
    ry: 0,
    transform: "translate(345 57)",
    fill: "#062"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ekOh59TsmJq6",
    transform: "translate(.000001 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 32,
    transform: "matrix(.970742-.240123 0.240123 0.970742 579.740997 103.584169)",
    fill: "#062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.977,254.717L591.119,120.642l-18.993-6.52-72.148,140.423l23,.025l59.123-116.438l57.376,116.561l22.5.024Z",
    fill: "#062",
    stroke: "#062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.972,259.654c-.013,12.319-10.6,22.989-24.524,22.974-13.924-.014-24.489-10.707-24.476-23.026.013-12.318,10.601-22.988,24.525-22.974c13.924.015,24.488,10.708,24.475,23.026Z",
    fill: "none",
    stroke: "#062",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 243,
    height: 157,
    rx: 0,
    ry: 0,
    transform: "matrix(.999999 0.001057-.001057 0.999999 457.47907 252.999874)",
    fill: "#062",
    stroke: "#062"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ekOh59TsmJq11",
    transform: "translate(.000001 0.000001)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 32,
    transform: "matrix(.970742-.240123 0.240123 0.970742 149.559052 217.701998)",
    fill: "#062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.978,367.304c-.079,74.007-64.613,133.932-144.142,133.848C65.3072,501.068,0.89966,441.006,0.977905,367c0,0,64.470995.068,144.000095.152c79.529.084,144,.152,144,.152Z",
    fill: "#062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.625,228.168l-29-.031L57.4737,371.06l24.5.026L136.09,261.143l-.116,110l21,.022.116-110l54.384,110.057l26,.028-77.849-143.082Z",
    fill: "#062"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "ekOh59TsmJq15",
    width: 450.649,
    height: 37,
    rx: 0,
    ry: 0,
    transform: "matrix(.969067-.246798 0.246798 0.969067 144.61902 196.384934)",
    fill: "#062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSpinner);
export default __webpack_public_path__ + "static/media/custom-spinner.9392d461a18fd5137b69519731771be9.svg";
export { ForwardRef as ReactComponent };